import { createResource, type RouteResource } from 'react-resource-router';

import type { UserAccessRights } from '../../../common/types/user-access-rights';
import { getUserRights } from '../endpoints';

export const userAccessRightsResource: RouteResource<UserAccessRights> =
	createResource<UserAccessRights>({
		type: 'userAccessRightsResource',
		getKey: (routerContext) => {
			const teamId = routerContext.match.params.teamId;
			return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
		},
		getData: (routerContext) => getUserRights(routerContext.match.params.teamId),
		maxAge: 60 * 60 * 1000, // 1 hour
		isBrowserOnly: true,
	});
